const ModalActionTypes = {
  MODAL_OPEN: "MODAL_OPEN",
  MODAL_CLOSE: "MODAL_CLOSE",
};

export default ModalActionTypes;
